module.exports = __webpack_public_path__ + "img/icon_xdyl.da428f85.png";